module.exports = __webpack_public_path__ + "f53db89907dadabbdbce942b1920ff4c.png";